module.exports = __webpack_public_path__ + "static/Medication in Hand-dfb50c0a6864ca353c4b82d159311e0a.jpg";